'use strict';

var aviaryColors = require('../../../../../../../../../_virtual/aviaryColors.cjs');

(function (exports) {

	exports.AVIARY_COLORS = void 0;
	(function(AVIARY_COLORS) {
	    AVIARY_COLORS["primary"] = "primary";
	    AVIARY_COLORS["info"] = "info";
	    AVIARY_COLORS["warning"] = "warning";
	    AVIARY_COLORS["danger"] = "danger";
	    AVIARY_COLORS["highlight"] = "highlight";
	    AVIARY_COLORS["system"] = "system";
	    AVIARY_COLORS["success"] = "success";
	})(exports.AVIARY_COLORS || (exports.AVIARY_COLORS = {}));
	
} (aviaryColors.__exports));
//# sourceMappingURL=aviaryColors.cjs.map
